"use client";

import { Eye, Grid2x2, ShoppingBag, Timer } from "lucide-react";

const ICON_MAP = {
  timer: Timer,
  "grid-2x2": Grid2x2,
  eye: Eye,
  "shopping-bag": ShoppingBag,
};

export default function Tag({ title, iconName, children, className = "" }) {
  const Icon = iconName ? ICON_MAP[iconName] : null;

  return (
    <div
      className={`px-4 mb-6 lg:mb-8 py-2.5 w-fit mx-auto rounded-full bg-black-light flex items-center gap-1 text-sm ${className}`}
    >
      {children}
      {Icon ? <Icon size={20} className="text-white me-0.5" /> : null}
      <span>{title}</span>
    </div>
  );
}
